import merge from "lodash/merge"

class ConfAffairs {
  constructor() {
    this.id = 0
    this.dining = ""
    this.link = ""
    this.conference_id = 0
    this.create_time = new Date()
    this.update_time = new Date()
  }
  static getList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/confaffairs"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let returndata = {}
      returndata.result = []
      let c = new ConfAffairs()
      res.data.results.forEach((x) => {
        let c = new ConfAffairs()
        Object.assign(c, x)
        returndata.result.push(c)
      })
      returndata.total = res.data.total
      return returndata
    })
  }

  static async get_first(){
    const res = await ConfAffairs.getList({})
    return res.result[0]
  }
}
export { ConfAffairs }
